<div class="wrapper">
  <div class>
    <div class="order-circle">{{ order }}</div>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
